<template>
  <b-card
    class="mb-0 h-100 hover"
    body-class="d-flex flex-direction-column"
  >
    <span
      class="hover-visible edit-gallery-item shadow"
    >
      <b-button
        v-b-modal.edit-item-modal
        class="p-0 h-100"
        size="sm"
        variant="link"
        @click="editCreative(creative)"
      >
        <GjIcon
          class="text-secondary"
          name="Edit"
        />
      </b-button>
    </span>
    <a
      @click="openPreview"
    >
      <b-card
        class="border mb-2"
        body-class="p-0"
      >
        <template v-if="creative.creativeType == 1">
          <div
            class="item-image text-center mx-auto"
            :style="{ backgroundImage: 'url(' + creative.url + ')' }"
          />
        </template>
        <template v-else>
          <!--TODO: Find image url-->
          <div
            class="item-image text-center mx-auto"
            style="background-image: url('https://localhost:44354/images/illustrations/iframe.svg')"
          />
        </template>
      </b-card>
    </a>
    <div
      class="position-relative d-inline"
    ><b-card-title
      class="mb-1"
    >
      {{ creative.name }}
    </b-card-title>
    </div>
    <div
      v-if="creative.tags.length > 0"
      class="position-relative mb-1 d-inline"
    >
      <Tags
        :tag-key="creative.id"
        :tags="creative.tags"
      />
    </div>
    <b-button
      v-else
      v-b-modal.edit-item-modal
      class="mb-1 d-flex justify-content-start p-0"
      variant="link"
      block
      size="sm"
      @click="editCreative(creative)"
    >
      <GjIcon
        class="mr-50"
        name="Plus"
      />
      {{ $tk('ClientPortal.Form.Gallery.AddTags') }}
    </b-button>
    <div class="mt-auto">
      <p
        v-for="(metadata,index) in creative.metadata"
        :key="index"
        class="mb-50 metadata-txt"
      >
        <span>
          {{ metadata.key }}:
        </span>
        <span class="text-secondary">
          {{ metadata.value }}
        </span>
      </p>
    </div>
    <image-preview-modal
      ref="imagePreview"
      :creative="creative"
    />
    <div v-if="creative.editMode">
      <b-modal
        id="edit-item-modal"
        :title="$tk('ClientPortal.Form.Actions.Edit')"
        :ok-title="$tk('ClientPortal.Form.Actions.Save')"
        :cancel-title="$tk('ClientPortal.Form.Actions.Cancel')"
        cancel-variant="outline-secondary"
        centered
        no-enforce-focus
        @hidden="cancelCreative(creative)"
        @ok="saveCreative(creative)"
      >
        <b-form-group
          class="mb-2"
          :label="$tk('ClientPortal.Gallery.EditTitle')"
        >
          <b-form-input
            v-model="creative.name"
            class="pr-5"
            type="text"
          />
        </b-form-group>
        <b-form-group
          class="mb-0"
          :label="$tk('ClientPortal.Gallery.EditTags')"
        >
          <b-form-tags
            v-model="creative.tags"
            tag-pills
            :disable-add-button="true"
            separator=","
            tag-variant="link"
            add-button-variant="outline-primary btn-sm ml-50"
            class="py-25 px-75"
            tag-class="mt-25 mr-50 mb-0 edit-tag-item"
            :invalid-tag-text="$tk('ClientPortal.Gallery.MaximumTagLengthIs255Characters')"
            remove-on-delete
            :tag-validator="(tag) => tag.length <= 255"
          />
        </b-form-group>
      </b-modal>
    </div>
  </b-card>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import GalleryService from '@/api/client/gallery.service'
import notification from '@/mixins/toastification'
import ImagePreviewModal from '@/components/ImagePreviewModal.vue'
import Tags from '@/views/client/ads-manager/gallery/Tags.vue'

export default {
  components: {
    GjIcon,
    ImagePreviewModal,
    Tags,
  },
  mixins: [notification],
  props: {
    creative: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      temporaryName: '',
      temporaryTags: [],
    }
  },
  methods: {
    editCreative(creative) {
      this.temporaryName = this.creative.name
      this.temporaryTags = this.creative.tags
      this.$set(creative, 'editMode', true)
    },
    cancelCreative(creative) {
      this.$set(creative, 'editMode', false)
      this.creative.name = this.temporaryName
      this.creative.tags = this.temporaryTags
    },
    async saveCreative(creative) {
      let tempTags = []
      let tempName
      try {
        tempTags = creative.tags
        tempName = creative.name
        const response = await GalleryService.updateCreative(creative.id, creative, this.$route.params.accountId)
        if (response.saved) {
          creative.tags = tempTags
          creative.name = tempName
          this.success(response.message)
          this.$set(creative, 'editMode', false)
        } else { this.error(response.message) }
      } catch (error) {
        this.error(error.message)
      } finally {
        this.temporaryName = ''
        this.temporaryTags = []
      }
    },
    openPreview() {
      this.$refs.imagePreview.previewCreative()
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/views/client/ads-manager/gallery/gallery-item.scss';
.edit-tag-item{
    background-color: white;
    color: #052D61;
    border: solid 1px #E0E5EB;
    border-radius: 20px;
    padding: 4px 8px;
    margin-right: 4px;
    display: inline;
}
.invalid-feedback {
    word-break: break-word;
}
</style>
